import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminWithdrawals, useUpdateWithdrawStatus } from "../../hooks/useAdmin";
import Card from "../../components/ui/Card";
import Badge from "../../components/ui/Badge";
import Button from "../../components/ui/Button";
import StatCard from "../../components/ui/StatCard";
import RiskMeter from "../../components/ui/RiskMeter";


const fmt = (n:number) => new Intl.NumberFormat("en-NG",{style:"currency",currency:"NGN", currencyDisplay:"symbol",maximumFractionDigits:0}).format(n);
const fmtDate = (d:string) => d ? new Date(d).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"}) : "—";
const statusColor = (s:string):any => s==="active"?"emerald":s==="repaid"?"blue":s==="overdue"?"red":s==="pending-surety"?"amber":"slate";

export default function AdminWithdrawalsPage() {  
  const navigate = useNavigate();
  const [filter, setFilter] = useState("all");
  const { data: withdraw = [] } = useAdminWithdrawals(filter !== "all" ? {withdraw_status:filter} : undefined) as any;
  const updateStatus = useUpdateWithdrawStatus();

  const totalDisbursed   = withdraw.filter((l:any)=>["disbursed"].includes(l.withdrawal_status)).reduce((s:number,l:any)=>s+Number(l.amount),0);
  const totalRequested   = withdraw.filter((l:any)=>["requested"].includes(l.withdrawal_status)).reduce((s:number,l:any)=>s+Number(l.amount),0);
  const totalApproved    = withdraw.filter((l:any)=>["approved"].includes(l.withdrawal_status)).reduce((s:number,l:any)=>s+(Number(l.amount)),0);
  //const totalDeclined    = withdraw.length ? Math.round(withdraw.reduce((s:number,l:any)=>s+(l.risk_score||60),0)/loans.length) : 0;

  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
        <StatCard label="Total Disbursed"  value={fmt(totalDisbursed)}   color="text-emerald-600"/>
        <StatCard label="Total Approved"      value={fmt(totalApproved)}  color="text-violet-600"/>
        <StatCard label="Total Requested"    value={fmt(totalRequested)} color="text-blue-600"/>
        {/* <StatCard label="Avg Risk Score"   value={avgRisk}                sub="higher = safer" color="text-slate-700"/> */}
      </div>

      <div className="flex gap-2 mb-4 flex-wrap">
        {["all","requested","approved","disbursed"].map(f => (
          <Button key={f} size="sm" variant={filter===f?"primary":"secondary"} onClick={()=>setFilter(f)}>
            {f==="all"?"All":f.charAt(0).toUpperCase()+f.slice(1)}
          </Button>
        ))}
      </div>

      <Card className="p-0 overflow-hidden">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-slate-50">
              {["ID","Requester","Amount","Status","Date","Actions"].map(h=>(
                <th key={h} className="px-4 py-3 text-left text-xs font-medium text-slate-500 border-b border-slate-200">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {withdraw.map((l:any) => (
              <tr key={l.id} className="border-b border-slate-100" >
                <td className="px-4 py-3 text-xs font-medium text-slate-500">{l.id?.slice(0,8)}…</td>
                <td className="px-4 py-3 text-sm text-slate-800">{l.name}</td>
                <td className="px-4 py-3 text-sm font-medium text-slate-800">{fmt(l.amount)}</td>                
                <td className="px-4 py-3"><Badge label={l.withdrawal_status} color={statusColor(l.withdrawal_status)}/></td>
                <td className=" text-sm">
                  <span className="text-xs text-slate-400">
                    {new Date(l.created_at).toLocaleString("en-US",{month:"short",day:"numeric",hour:"2-digit",minute:"2-digit"})}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <div className="flex gap-1.5">
                    <Button variant="ghost" size="sm" onClick={() => navigate(`/admin/memberwithdraw/${l.id}`)}>View Details</Button>
                    {l.withdrawal_status==="requested"        && <Button size="sm" variant="primary"    onClick={()=>updateStatus.mutate({id:l.id,status:"approved",accountId:l.account_id,memberId:l.member_id,amount:l.amount})}>Approve Withdrawal</Button>}
                    {l.withdrawal_status==="approved" && <Button size="sm" variant="amber"     onClick={()=>updateStatus.mutate({id:l.id,status:"disbursed",accountId:l.account_id,memberId:l.member_id,amount:l.amount})}>Disburse Fund</Button>}
                    {l.withdrawal_status==="disbursed" && <Button size="sm" variant="danger" onClick={() => navigate(`/admin/loans/${l.id}`)}>Archive</Button>}                    
                  </div>
                </td>
              </tr>
            ))}
            {withdraw.length===0 && <tr><td colSpan={8} className="px-4 py-10 text-center text-sm text-slate-400">No withdrawal/request found</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
